import { render, staticRenderFns } from "./bookingNotPossible.vue?vue&type=template&id=0297711a&scoped=true&"
import script from "./bookingNotPossible.vue?vue&type=script&lang=js&"
export * from "./bookingNotPossible.vue?vue&type=script&lang=js&"
import style0 from "./bookingNotPossible.vue?vue&type=style&index=0&id=0297711a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0297711a",
  null
  
)

export default component.exports